module.exports = __webpack_public_path__ + "img/add.b9cbb085.svg";